import { render, staticRenderFns } from "./FileUploadIcon.vue?vue&type=template&id=363fded6"
import script from "./FileUploadIcon.vue?vue&type=script&lang=js"
export * from "./FileUploadIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports